/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

export const clickableTableWrapper = css`
  outline: none;
  cursor: zoom-in;
`

export const modalContainer = css`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  overflow: auto;
  padding: 16px;
`

export const modalContent = css`
  background: white;
  border-radius: 10px;
  max-width: 95%;
  max-height: 95%;
  overflow: auto;
  position: relative;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.25);
`

export const closeButton = css`
  position: sticky;
  top: 8px;
  float: right;
  margin: 8px;
  z-index: 1;
`

export const enlargedTable = (modalMinWidth: number) => css`
  min-width: ${modalMinWidth}px;
`
